/**
 * A venue's billing status as a badge.
 *
 * Separate from StatusBadge.jsx on purpose. That one speaks TOURNAMENT statuses,
 * where 'active' means a night in progress and takes the gold badge. A billing
 * 'active' is a paying venue and has to read as success. Same word, two
 * vocabularies — one component holding both maps would be one component that
 * has to be told which domain it is in on every use.
 *
 * The label and variant maps stay separate for the reason StatusBadge gives:
 * statuses outnumber treatments, and collapsing them here is what stops a
 * status picking its own colours inline (V2-DESIGN-REFERENCE.md §2.6).
 */

/** Mirrors functions/lib/venues.js. Order is the lifecycle, not the alphabet. */
export const BILLING_STATUSES = ['pending', 'trial', 'active', 'suspended', 'cancelled'];

export const STATUS_LABELS = {
  pending:   'Pending',
  trial:     'Trial',
  active:    'Active',
  suspended: 'Suspended',
  cancelled: 'Cancelled',
};

/**
 * `suspended` takes .hd-badge-pending because that class IS the amber/warning
 * treatment; the class names describe the look, and that one is misleadingly
 * named after the first status that happened to use it.
 */
const STATUS_VARIANTS = {
  pending:   'neutral',
  trial:     'info',
  active:    'success',
  suspended: 'pending',
  cancelled: 'danger',
};

export default function BillingBadge({ status }) {
  // An unmapped status shows its raw value rather than vanishing — a status
  // added server-side should look wrong, not look like nothing.
  const variant = STATUS_VARIANTS[status] ?? 'neutral';

  return (
    <span className={`hd-badge hd-badge-${variant}`}>
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
